"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COALESCE = void 0;
exports.COALESCE = {
    alias: 'PRIMEIRO_VALOR',
    description: 'Retorna o primeiro valor não vazio encontrado',
    arg_names: ['col 1', 'outros valores'],
    args_description: [
        'primeiro valor possívelmente vazio',
        '...outros valores possivelmente vazios',
    ],
};
